import React from 'react';
import './Cultureheader.css'; // Importe le CSS
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'; // Import de l'icône de flèche


function Cultureheader() {
  return (
    <div className="header-containerga26">
        <div className="boutton-containerga26">
                <div className='butga26'>
                  
             <button className="bouttonga26">GALERIE<ArrowForwardIcon className="1arrow-icon" />CULTURE ET SPORT</button>
             <h1>CULTURE ET SPORT</h1> 
            </div>
            </div>
    </div>
  );
}

export default Cultureheader;


